import { Middleware } from 'openapi-fetch';
import { match, P } from 'ts-pattern';
import { useApiStatusStore } from '../hooks/useApiStatusStore';

/**
 * Creates an openapi-fetch middleware for tracking the API connection status.
 */
export const createApiStatusMiddleware = (): Middleware => {
  return {
    async onResponse({ response }) {
      const { reportConnected, reportRateLimited, reportDisconnected } =
        useApiStatusStore.getState();

      try {
        match(response)
          .with({ ok: true }, () => {
            reportConnected();
          })
          .with({ status: 429 }, (response) => {
            const retryAfterString = response.headers.get('Retry-After');
            const retryAfter = Number(retryAfterString) * 1000;
            reportRateLimited(retryAfter || undefined);
          })
          .with({ status: P.when((status) => status >= 500) }, () => {
            reportDisconnected();
          });
      } catch (error) {
        console.error('Error in API status tracking:', error);
      }

      // Return the original response.
      return response;
    },

    async onError() {
      try {
        const { reportDisconnected } = useApiStatusStore.getState();
        reportDisconnected();
      } catch (storeError) {
        console.error('Error updating API status store:', storeError);
      }

      // Return nothing to propagate the original error.
      return;
    },
  };
};
